import Axios from '../../../utils/axios'
import axios from 'axios'
import { headers } from '../../../utils/token'
import moment from 'moment'

export const loadAuditTrail = (data) => dispatch => {
  return Axios.get('/admin/login-audit-trails', dispatch, 'GET_AUDIT_TRAIL', { headers: headers })
}
